import {
  FoundationalReportItem,
  HintItem,
  Live101TrainingItem,
  MethodGuideItem,
  TechGuideItem,
  VideoItem,
  GlossaryItem,
  SectorPrimer,
} from '@gslc/models';

export interface GlobalState {
  windowWidth: number;
  apiMockEnabled: boolean;
  videos: VideoItem[];
  videoSettings: any;
  live101Trainings: Live101TrainingItem[];
  methodGuides: MethodGuideItem[];
  technicalGuides: TechGuideItem[];
  hints: HintItem[];
  reports: FoundationalReportItem[];
  pageLoading: { loading: boolean; path: string };
  searchQuery: string;
  currentVideo: any;
  currentFoundationalReport: any;
  glossarySearch: string;
  glossarySearchIsLetter: boolean;
  glossaryLoading: boolean;
  glossaries: GlossaryItem[];
  sectorPrimers: SectorPrimer[];
}

export const globalState: GlobalState = {
  windowWidth: 0,
  apiMockEnabled: localStorage.getItem('api-mock-enabled') === 'true',
  videos: [],
  videoSettings: { hide_card_in_video: false },
  live101Trainings: [],
  methodGuides: [],
  technicalGuides: [],
  hints: [],
  reports: [],
  pageLoading: { loading: false, path: '/' },
  searchQuery: '',
  currentVideo: null,
  currentFoundationalReport: null,

  glossarySearch: '',
  glossarySearchIsLetter: false,
  glossaryLoading: false,
  glossaries: [],
  sectorPrimers: [],
};

export const getters = {
  windowWidth: (state: GlobalState): number => state.windowWidth,
  apiMockEnabled: (state: GlobalState): boolean => state.apiMockEnabled,
  videoSettings: (state: GlobalState): any => state.videoSettings,
  videos: (state: GlobalState): VideoItem[] => state.videos,
  live101Trainings: (state: GlobalState): Live101TrainingItem[] =>
    state.live101Trainings,
  methodGuides: (state: GlobalState): MethodGuideItem[] => state.methodGuides,
  technicalGuides: (state: GlobalState): TechGuideItem[] =>
    state.technicalGuides,
  hints: (state: GlobalState): HintItem[] => state.hints,
  reports: (state: GlobalState): FoundationalReportItem[] => state.reports,
  pageLoading: (state: GlobalState): { loading: boolean; path: string } =>
    state.pageLoading,
  searchQuery: (state: GlobalState): string => state.searchQuery,
  currentVideo: (state: GlobalState): any => state.currentVideo,
  currentFoundationalReport: (state: GlobalState): any =>
    state.currentFoundationalReport,
  glossarySearch: (state: GlobalState): string => state.glossarySearch,
  glossarySearchIsLetter: (state: GlobalState): boolean =>
    state.glossarySearchIsLetter,
  glossaryLoading: (state: GlobalState): boolean => state.glossaryLoading,
  glossaries: (state: GlobalState): GlossaryItem[] => state.glossaries,
  sectorPrimers: (state: GlobalState): SectorPrimer[] => state.sectorPrimers,
};
